import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import CircleApplicationForm from '~/features/circle-participation/components/CircleApplicationForm'
import Back from '~/shared/assets/icons/Back'
import theme from '~/shared/styles/theme'

function CircleApplyPage() {
  const navigate = useNavigate()

  return (
    <Wrapper>
      <BackBox onClick={() => navigate('/circle-participation/info')}>
        <Back />
        <span className="text">참가안내로 돌아가기</span>
      </BackBox>

      <CircleApplicationForm />
    </Wrapper>
  )
}

export default CircleApplyPage

const Wrapper = styled.section<any>`
  display: flex;
  flex-direction: column;
  gap: 60px;

  width: 100vw;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 50px 0;
  margin: 0 auto;
  padding-top: ${theme.size.headerHeight}px;

  @media ${theme.device.medium} {
    gap: 40px;
    width: 90vw;
  }
`

const BackBox = styled.div`
  cursor: pointer;

  display: flex;
  gap: 12px;
  align-items: center;

  margin-top: 20px;

  .text {
    font-family: NanumSquareNeo-Regular, sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
    color: ${theme.colors.grey_4};
  }
`
